export default({message, downloadUrl}) => `
    <p data-msg>
        ${message}
    </p>
    <div class="button-container">
        <a data-download-confirm data-cancel href="${downloadUrl}" role="button" class="button primary margin-small radius contrast u-allCaps confirm " aria-label="${html('confirm')}">${html('confirm')}</a>
        <button type="button" data-cancel class="button radius margin-small secondary cancel u-allCaps ">${html('cancel')}</button>
    </div>
`;
